import { useEffect, useState } from "react";

import { screenBreakpoints } from "../../config";

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
}

export function useWindowDimensions() {
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions(),
  );
  const currentScreenBreakpoint = (width: number) => {
    if (width > screenBreakpoints.xl) {
      return "xl";
    } else if (width > screenBreakpoints.lg) {
      return "lg";
    } else if (width > screenBreakpoints.md) {
      return "md";
    } else if (width > screenBreakpoints.sm) {
      return "sm";
    }
    return "xs";
  };
  const [screenBreakpoint, setScreenBreakpoint] = useState(
    currentScreenBreakpoint(windowDimensions.width),
  );

  useEffect(() => {
    function handleResize() {
      const dimensions = getWindowDimensions();
      setWindowDimensions(dimensions);
      setScreenBreakpoint(currentScreenBreakpoint(dimensions.width));
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return {
    windowDimensions,
    isSmallScreen: windowDimensions.width < screenBreakpoints.sm,
    isMediumScreen: windowDimensions.width < screenBreakpoints.md,
    isLargeScreen: windowDimensions.width < screenBreakpoints.lg,
    isXLareScreen: windowDimensions.width > screenBreakpoints.lg,
    screenBreakpoint,
  };
}
